<template>
    <div class="detailWrapper">
        <home-swiper :swiperList="swiperList"></home-swiper>
        <home-nav ref="nav"></home-nav>
        <div class="wrapper_all">
            <div class="wrapper_box">
                <detail-top 
                    :postDetail="postDetail" 
                    :isMask="isMask"
                    @handlePostInform="handlePostInform"
                ></detail-top>
                <detail-bot
                    :topicId="postDetail.id" 
                    :isMask="isMask" 
                    :commentNumber="commentNumber"
                    @handleCommentInform="handleCommentInform"
                    ref="detailBot"
                ></detail-bot>
            </div>
            <div class="back" @click="goBack()"><van-icon name="arrow-left" /></div>
        </div>
        <post-inform
                isMask="isMask"
                @closePostFrom="closePostFrom"
                @handleSelectInform="handleSelectInform"
                v-if="isMask"
            >
        </post-inform>
    </div>
</template>

<script>
import HomeNav from '@/components/HomeNav.vue'
import DetailTop from '@/components/DetailTop.vue'
import DetailBot from '@/components/DetailBot.vue'
import HomeSwiper from '@/components/HomeSwiper.vue'
import postInform from '@/components/PostInform.vue'

export default {
    name:'PostDetail',
    data() {
        return {
            timer:'',
            postDetail:{},
            commentNumber:0,
            defaultHeight: document.body.clientHeight,
            screenHeight: document.body.clientHeight,
            isMask:false,
            comment_id:''
        }
    },
    components:{
        HomeNav,
        DetailTop,
        DetailBot,
        HomeSwiper,
        postInform
    },
    computed: {
        userInfo () {
            return this.$store.state.userInfo
        },
        swiperList() {
            return this.$store.state.swiperList
        }
    },
    mounted() {
        this.getDetailInfo();
        const that = this
        // window.onscroll = () => {
        //     return (() => {
        //         document.body.clientHeight= this.$refs.detailBot.tops
        //     }) ()
        // }

    },
    methods: {
        closePostFrom() {
            this.isMask = false
        },
        handlePostInform() {
            this.isMask = true;
        },
        handleSelectInform(content) {

            if(this.comment_id) {
                this.$http.post('/comment/report', {
                    app_user_id: this.userInfo.app_user_id,
                    id: this.comment_id,
                    tag: content,
                    reason: content,
                    game_id: this.userInfo.game_id
                })
                    .then((response) => {
                        this.$toast('舉報成功!');
                        this.isMask = false;
                    })
                    .catch((error) => {
                    });
            } else {
                this.$http.post('/topic/report', {
                    app_user_id: this.userInfo.app_user_id,
                    id: this.$route.params.id,
                    tag: content,
                    reason: content,
                    game_id: this.userInfo.game_id
                })
                .then((response) => {
                    this.$toast('舉報成功!');
                    this.isMask = false;
                })
                .catch((error) => {
                    this.$toast(error.response.data);
                });
            }
            
        },
        handleCommentInform(id) {
            this.isMask = true;
            this.comment_id = id;
        },
        goBack() {
            this.$router.go(-1)
        },
        getDetailInfo() {
            let t = this;
            let input = {
                topic_id: this.$route.params.id,
                app_user_id: this.userInfo.app_user_id,
            };
            let api="https://forum.gamemorefun.net/api/topic/show";
            t.$http
                .get(api,{
                    params:input
                })
                .then((response) => {
                    let data = response.data;
                    t.postDetail = data;
                    t.commentNumber = data.comment_count;
                    // debugger
                })
        }
    }
}
</script>

<style lang="stylus" scoped>
.detailWrapper{
    width:100%;
    height:100%;
    min-height: 101%
}
.mescroll{
    position fixed
}
@media all and (orientation : landscape)
    .van-icon-arrow-left
        color: #fff;
        font-size: 0.4rem;
        vertical-align: middle;
    .back
        width .6rem
        height .6rem
        line-height: .55rem;
        background: #fe8124;
        border-radius: 100%;
        position: fixed;
        right: 3%;
        bottom: 30%;
        z-index: 0;
        text-align: center;
    .wrapper_all
        position: relative;
        z-index: 9;
        width: 85%;
        height: 100% !important;
        min-height: 101%
        margin: 0 auto;
        padding: 10px 0;
        height: 100%;
        -webkit-overflow-scrolling: touch;
    .wrapper_box
        width: 100%;
        height: 100% !important;
        position: relative;
        min-height: 101%
        color: #fff;
    .detail
        max-width 750px
        margin 0 auto
    .post
        width: 100%;
        .comment
            .comment_ul
                li
                    border-bottom none
                    &.post_dis
                        display flex
                    .left
                        flex 1
                        input
                            width: 110%;
                            height: 76%;
                            color #000
                            padding-left 2%
                    .right
                        flex: 1;
                        text-align: right;
                        .van-icon-arrow-left
                            width: .5rem;
                            height: .5rem;
                            border-radius: 100%;
                            line-height: .5rem;
                            text-align: center;
                            font-size: 0.32rem;
                            vertical-align: middle;
                            background: #d2a852;
                    .btn
                        color: #fff;
                        border-radius: 0.1rem;
                        background: #d2a852;
                        padding: 0.05rem 0.3rem;
                        margin-right: 10%;
                        vertical-align: middle;
                    &:nth-child(1)
                        display flex
                        border-bottom 1px solid #797979
                    .l_w
                        flex 1
                        text-align left
                    .r_w
                        flex 1
                        text-align right
                        span
                            padding .1rem .3rem
                            border: 1px solid #797979
                            border-radius: 0.1rem
        ul
            width 100%
            height 100%
            li
                line-height .6rem
                font-size 0.275rem
                color #fff
                text-align left
                padding 0 0.2rem
                margin .1rem .25rem
                padding-bottom .08rem
                .active
                    color: #19a15f
                .subAdd
                    margin-left 5%
                .post_content
                    display flex
                    border-bottom 1px solid #797979
                    padding-bottom: .04rem
                .content
                    padding 2% 0
                    .post_rw
                        flex .3!important
                    .left
                        flex 1
                        img
                            float: left
                            margin-right: 3%
                            width: .5rem
                            height: .5rem
                        .r
                            display flex
                            flex-direction column
                            i
                                color: #fff
                                background: #19a15f
                                padding: .01rem .06rem
                                font-size: .1rem
                                margin-right: 3%
                            p
                                flex 1
                                &.name
                                    color #d2a852
                        span
                            display inline-block
                            &.name
                                padding-left 6%
                                padding-right 6%
                            &.time
                                padding-right 6%
                    .right
                        flex .7
                        display flex
                        text-align right
                        div
                            display inline-block
                            flex 1
                            padding-left 6%
                            a
                                color #fff
                            .van-icon
                                display inline-block
                                margin-top 0
                                margin-right 6%
                                font-size .325rem
                                color #fff
                            i
                                display inline-block
                                font-style normal
                                vertical-align middle
@media all and (orientation : portrait)
    .wrapper_box
        width: 100%;
        height: 100%;
        color: #fff;
        background: #333;
    .detail
        max-width 750px
        margin 0 auto
    .post
        width 100%
        color #fff
        &.addH
            margin-top 13%
        ul
            width 100%
            height 100%
            li
                line-height .6rem
                color #fff
                text-align left
                border-bottom 1px solid #797979
                padding 0 0.2rem
                margin .1rem .25rem
                font-size .255rem
                .active
                    color: #19a15f
                .post_content
                    display flex
                    .left
                        flex 1.1
                        span
                            display inline-block
                            &.name
                                padding-left 6%
                                padding-right 6%
                            &.time
                                padding-right 6%
                    .right
                        flex .7
                        display flex
                        text-align right 
                        span
                            display inline-block
                            flex 1
                            padding-left 6%
                            .van-icon
                                display inline-block
                                margin-top 0
                                margin-right 6%
                                font-size .325rem
                                color #fff
                            i
                                display inline-block
                                font-style normal
                                vertical-align middle 

</style>